import { FilterCollapse } from 'libs/athos/components/collection/filters/FilterCollapse'
import { useSort } from 'libs/athos/hooks/useSort'

export function FilterSort() {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  const options = [
    { id: 'default', label: 'Recommended', checked: !activeSort, onSelect: resetSort },
    ...sorts.map((sort) => ({
      id: sort.value,
      label: sort.label,
      checked: activeSort === sort.value,
      onSelect: () => handleSort(sort.value)
    }))
  ]

  return (
    <FilterCollapse label="Sort By">
      <div className="flex flex-col gap-y-1.5 px-1.5 pb-1.875 pt-0.75">
        {options.map((option) => (
          <div className="group/filter-item relative flex w-full cursor-pointer items-center gap-x-0.5" key={option.id}>
            <input
              id={`sort__${option.id}`}
              className="peer field-radio shrink-0"
              type="radio"
              name="sort"
              value={option.id}
              checked={option.checked}
              onClick={option.onSelect}
              aria-label={option.label}
            />
            <label
              for={`sort__${option.id}`}
              className="flex grow cursor-pointer w-full items-center heading-xs text-type-black-primary"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </FilterCollapse>
  )
}
